import { useCallback, useEffect, useState } from 'react';
import { oauth } from '../utils';


export interface PoDCredentialStatus {
  configured: boolean;
  division_id: string | null;
  supplier: {
    pod_supplier_id?: string;
  };
  account_id: string | null;
}

export function buildPoDCredentialStatusEndpoint() {
  return 'pod/credential';
}

export function createDefaultPoDCredentialStatus(): PoDCredentialStatus {
  return {
    configured: false,
    division_id: null,
    supplier: {},
    account_id: null,
  };
}

export function usePoDCredentialStatus(
  enabled = true,
  divisionId?: string | null,
) {
  const [credentialStatus, setCredentialStatus] = useState<PoDCredentialStatus>(
    createDefaultPoDCredentialStatus(),
  );
  const [isLoading, setIsLoading] = useState(enabled);
  const [error, setError] = useState<unknown>(null);

  const reload = useCallback(async () => {
    if (!enabled) {
      setCredentialStatus(createDefaultPoDCredentialStatus());
      setIsLoading(false);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const response = await oauth(
        'GET',
        buildPoDCredentialStatusEndpoint(),
        divisionId ? { division_id: divisionId } : {},
      );
      setCredentialStatus(response?.json ?? createDefaultPoDCredentialStatus());
    } catch (e) {
      setCredentialStatus(createDefaultPoDCredentialStatus());
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, [enabled, divisionId]);

  useEffect(() => {
    reload();
  }, [reload]);

  return {
    credentialStatus,
    isLoading,
    error,
    reload,
    setCredentialStatus,
  };
}
